// The product type assessment dialog.
export const T = {
  en_GB: {
    title: "Assessment",
    description:
      "Configure the suitability assessment for this product type. Enable a quiz, a questionnaire, or both — each with its own questions and pass score. Every question has point-scored options; a mode passes when the summed score of its answered questions meets its pass score, and with both modes on the client must pass both. With no mode enabled the type falls back to a plain yes/no experience declaration.",
    modeQuestionnaire: "Questionnaire",
    modeQuiz: "Quiz",
    incomplete: "Incomplete",
    removeTitle: "Remove assessment",
    removeDescription:
      "Turning a mode off deletes its questions and settings. If no mode is left enabled, the product type falls back to a plain yes/no experience declaration. This action cannot be undone.",
    remove: "Remove",
    cancel: "Cancel",
    save: "Save",
    failedToSave: "Failed to save assessment",
  },
  nb_NO: {
    title: "Vurdering",
    description:
      "Konfigurer egnethetsvurderingen for denne produkttypen. Aktiver quiz, spørreskjema eller begge — hver med egne spørsmål og beståttgrense. Hvert spørsmål har poengsatte svaralternativer; en modus bestås når den samlede poengsummen for de besvarte spørsmålene når beståttgrensen, og med begge modusene på må kunden bestå begge. Uten noen modus aktivert faller typen tilbake til en enkel ja/nei-erklæring.",
    modeQuestionnaire: "Spørreskjema",
    modeQuiz: "Quiz",
    incomplete: "Ufullstendig",
    removeTitle: "Fjern vurdering",
    removeDescription:
      "Å slå av en modus sletter dens spørsmål og innstillinger. Hvis ingen modus er aktivert, faller produkttypen tilbake til en enkel ja/nei-erklæring. Denne handlingen kan ikke angres.",
    remove: "Fjern",
    cancel: "Avbryt",
    save: "Lagre",
    failedToSave: "Kunne ikke lagre vurdering",
  },
} as const;
